import {verifiedFetch} from '@github-ui/verified-fetch'
import type {FeedbackSubmitHandler} from './types'
import {useCallback} from 'react'

interface useHandleFeedbackSubmitProps {
  path: string
  additionalParameters?: Record<string, string>
}

export const useHandleFeedbackSubmit = ({path, additionalParameters}: useHandleFeedbackSubmitProps) =>
  useCallback(
    ({type, commentId, feedbackChoice, textResponse}) => {
      try {
        const body = new FormData()
        body.set('comment_id', commentId)
        body.set('feedback', type)
        if (additionalParameters) {
          for (const [key, value] of Object.entries(additionalParameters)) {
            body.set(key, value)
          }
        }
        for (const choice of feedbackChoice ?? []) body.append('feedback_choice[]', choice)
        if (textResponse) body.set('text_response', textResponse)
        verifiedFetch(path, {method: 'POST', body})
      } catch {
        // nothing users can really do here, so just fail silently
      }
    },
    [path, additionalParameters],
  ) as FeedbackSubmitHandler
